import ElementsPromoItemsBlock from './elementsPromoItemsBlock'

export default ElementsPromoItemsBlock
